module.exports = __webpack_public_path__ + "static/media/Margaery Tyrell 1.490ac3cd.jpg";